declare global {
  interface Window {
    SFX: typeof SFX
    sfx: typeof SFX
  }
}

const SFX = {
  async deleteDBs(reloadPage = true) {
    console.debug("DELETING ALL DBS")
    const dbs = await window.indexedDB.databases()

    for (const db of dbs) {
      if (db.name) window.indexedDB.deleteDatabase(db.name)
    }

    if (reloadPage) {
      console.debug("RELOADING PAGE")
      location.reload()
    }
  },

  deleteLocalStorage(keepLogin = true) {
    console.debug("DELETING LOCAL STORAGE")

    if (keepLogin) {
      const authStoreKey = "pinia-authStore"
      const authStoreValue = localStorage.getItem(authStoreKey)

      localStorage.clear()

      if (authStoreValue) localStorage.setItem(authStoreKey, authStoreValue)
    } else {
      console.debug("BYE BYE LOGIN DETAILS")
      localStorage.clear()
    }
  },

  async logout(deleteCredentials = false) {
    const { useAuthStore } = await import("src/stores/authStore")
    const authStore = useAuthStore()

    await authStore.logout()

    if (deleteCredentials) {
      console.debug("BYE BYE CLIENT CREDENTIALS")
      authStore.clientCredentials = null
    }
  },

  async nukeEverything() {
    console.debug("🙃🙃🙃🙃🙃🙃🙃🙃🙃🙃")
    this.deleteLocalStorage(false)
    await this.deleteDBs()
  },

  async fetchData(workspaceId: string) {
    const { dataFetchDialog } = await import("src/util/functions/dialogs")
    await dataFetchDialog(workspaceId)
  },

  isItFriday() {
    const date = new Date()
    const day = date.getDay()

    if (day === 5) {
      console.debug("🥳 YES, IT IS 🥳")
      return true
    } else {
      console.debug("😭 NO, IT IS NOT 😭")
      return false
    }
  },
}

window.SFX = SFX
window.sfx = SFX

export {}
